// src/Pages/Home.js
import React from 'react';

const Productivity = () => {
  return <div>Welcome to Home Page</div>;
};

export default Productivity;
